import { render, staticRenderFns } from "./ImageWithButtonsBlock.vue?vue&type=template&id=4f439fd6&scoped=true&"
import script from "./ImageWithButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./ImageWithButtonsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithButtonsBlock.vue?vue&type=style&index=0&id=4f439fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f439fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f439fd6')) {
      api.createRecord('4f439fd6', component.options)
    } else {
      api.reload('4f439fd6', component.options)
    }
    module.hot.accept("./ImageWithButtonsBlock.vue?vue&type=template&id=4f439fd6&scoped=true&", function () {
      api.rerender('4f439fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/ImageWithButtonsBlock/ImageWithButtonsBlock.vue"
export default component.exports